import { resolveImagePath } from '@/utils/imageMap';

export function WelcomeSection() {
  return (
    <section className="bg-gray-100 py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* MD Helicopters Image - Left Side */}
          <div className="lg:col-span-1">
            <div className="text-center">
              <img
                src={resolveImagePath('/images/md-helicopters-thoroughbred.jpg')}
                alt="MD Helicopters - Thoroughbred Aviation"
                className="w-full h-48 object-cover rounded-lg shadow-sm"
              />
            </div>
          </div>
          
          {/* Main Welcome Content */}
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">
              Welcome to Thoroughbred Aviation
            </h2>
            
            <div className="space-y-4 text-gray-600">
              <p>
                Count on Thoroughbred Aviation for all of your aviation maintenance needs. We provide avionics 
                installation, repair and inspections, aircraft painting, interiors, scheduled and unscheduled service, 
                airframe repair and more. We stock and provide a wide array of parts. Are you interested in 
                mobile maintenance? We've got you covered for that, as well. Thoroughbred Aviation supports 
                numerous Federal, State and Local government aircraft and law enforcement agencies along with 
                aircraft used for Aerial Photography.
              </p>
              
              <p>
                Thoroughbred Aviation Maintenance has secured two five-year contracts with the U.S. Department 
                of Agriculture (USDA) to maintain two Airbus H120 utility helicopters. {" "}
                <a 
                  href="https://www.verticalmag.com/press-releases/thoroughbred-aviation-maintenance-maintain-utility-helicopters-usda/"
                  className="text-blue-800 hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Click here to read our press release at Vertical Magazine: "Thoroughbred Aviation Maintenance to maintain utility helicopters for USDA"
                </a>
              </p>
              
              <p>
                We partner with {" "}
                <a 
                  href="https://thoroughbredhelicopters.com/"
                  className="text-blue-800 hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Thoroughbred Helicopter Sales & Leasing
                </a>
                {" "} to provide quality aircraft for lease or purchase. Visit {" "}
                <a 
                  href="https://thoroughbredhelicopters.com/"
                  className="text-blue-800 hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  their website
                </a>
                {" "} for information on currently available aircraft.
              </p>
              
              <p>
                Looking for t-shirts with our cool logo? We've still got a few in stock – call us today!
              </p>
            </div>
          </div>
          
          {/* Special Projects Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold text-gray-800 mb-6 text-center">
                Special Projects
              </h3>
              
              <div className="space-y-6">
                {/* HeavyD's First Huey YouTube Video */}
                <div className="text-center">
                  <div className="mb-4">
                    <a 
                      href="https://www.youtube.com/watch?v=CGSV5saDHnE"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block"
                    >
                      <div className="w-full h-32 bg-black rounded flex items-center justify-center relative overflow-hidden">
                        <div className="text-white">
                          <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-2">
                            <svg className="w-6 h-6 text-white fill-current" viewBox="0 0 24 24">
                              <path d="M8 5v14l11-7z"/>
                            </svg>
                          </div>
                          <div className="text-sm">Watch Video</div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <h4 className="font-bold text-gray-800 text-base">HeavyD's First Huey!</h4>
                </div>
                
                {/* HeavyD's Black Hawk Project */}
                <div className="text-center">
                  <div className="mb-4">
                    <a 
                      href="https://thoroughbredaviationmaintenance.com/black-hawk-project/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={resolveImagePath('/images/heavyd-blackhawk.png')}
                        alt="Thoroughbred Aviation Maintenance - rebuild and maintenance of HeavyD Spark's Blackhawk helicopter"
                        className="w-full h-32 object-cover rounded"
                      />
                    </a>
                  </div>
                  <h4 className="font-bold text-gray-800 text-base">HeavyD's Black Hawk Project</h4>
                </div>
                
                {/* Cleetus McFarland's MD500 Project */}
                <div className="text-center">
                  <div className="mb-4">
                    <a 
                      href="https://thoroughbredaviationmaintenance.com/cleetus-macfarland-md500-project/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={resolveImagePath('/images/cleetus-md500.png')}
                        alt="Cleetus McFarland's MD500 Project - Thoroughbred Aviation Maintenance"
                        className="w-full h-32 object-cover rounded"
                      />
                    </a>
                  </div>
                  <h4 className="font-bold text-gray-800 text-base">Cleetus McFarland's MD500 Project</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}